import { useDeviceType } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { useGetFskBanner } from './useGetFskBanner';
import { useProPlusBanner } from './useProPlusBanner';
import { useRealtorReportBanner } from './useRealtorReportBanner';
import { EBanners } from '../../../constants/banners';
import { selectIsCpdAvailableForCurrentRegion } from '../../../selectors/cpd/selectIsCpdAvailableForCurrentRegion';
import { selectJsonQuery } from '../../../selectors/results';
import { selectIsUserAgent } from '../../../selectors/user';
import { isProPlus } from '../../../utils/bannerPackages';

export function useGetCurrentBanner(): EBanners | null {
  const deviceType = useDeviceType();
  const jsonQuery = useSelector(selectJsonQuery);

  const userIsAgent = useSelector(selectIsUserAgent);
  const isCpdAvailable = useSelector(selectIsCpdAvailableForCurrentRegion);

  const proPlusBannerType = useProPlusBanner();
  const fskBannerType = useGetFskBanner(proPlusBannerType);
  const realtorReportBannerType = useRealtorReportBanner();
  const isDesktop = deviceType === 'desktop';

  if (fskBannerType) {
    return EBanners.Fsk;
  }

  const leadsBannerType = !userIsAgent && isDesktop && EBanners.Leads;
  const cpdBannerType: EBanners | null = !userIsAgent && isDesktop && isCpdAvailable ? EBanners.CPD : null;

  if (isProPlus(jsonQuery)) {
    let desktopStubType: EBanners | null = null;
    if (realtorReportBannerType) {
      desktopStubType = realtorReportBannerType;
    } else if (cpdBannerType) {
      desktopStubType = cpdBannerType;
    } else if (leadsBannerType) {
      desktopStubType = leadsBannerType as EBanners;
    }
    const mobileStubType = fskBannerType || realtorReportBannerType || EBanners.Empty;
    const stubBannerType = isDesktop ? desktopStubType : mobileStubType;

    return (proPlusBannerType || stubBannerType) as EBanners | null;
  }

  return (realtorReportBannerType || cpdBannerType || leadsBannerType || null) as EBanners | null;
}
